
export default [
  {
    path: '/admin/motor-risks',
    name: 'motor-risks',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/motor-risk')
  }
]
